<script lang="ts">
	import type { ClassValue } from 'svelte/elements';
	import { generateRandomWords } from '$lib/utils/generateRandomWords';

	interface Props {
		minWords?: number;
		maxWords?: number;
		minWordLength?: number;
		maxWordLength?: number;
		text?: string;
		tag?: string;
		class?: ClassValue;
		ariaHidden?: boolean;
	}

	const {
		minWords = 0,
		maxWords = 0,
		minWordLength = 4,
		maxWordLength = 15,
		text = '',
		tag = 'span',
		class: classes,
		ariaHidden = true,
	}: Props = $props();

	const words = $derived((
		generateRandomWords({
			minWords,
			maxWords,
			minWordLength,
			maxWordLength,
		}) || text
	)
		.trim()
		.split(/\s+(?=\S{4,})/)
		.filter(w => w.length));
</script>

<svelte:element this={tag}
	class={['flex items-center gap-x-1 text-transparent select-none', classes]}
	data-testid="loading"
	aria-hidden={ariaHidden}
>
	<!-- eslint-disable-next-line svelte/require-each-key -->
	{#each words as word}
		<span class="bg-neutral-soft b-rounded-full leading-none my-0.5">{word}</span>
	{/each}
</svelte:element>
